import React, { useState } from "react";
import Layout from "../components/Layout";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const [form, setForm] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(form.email, form.password);
      toast.success("Welcome back!");
      nav("/game");
    } catch (err) {
      toast.error(err.message || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout hideNav>
      <div className="px-5 py-10 max-w-sm mx-auto cb-rise">
        <h1
          className="font-pixel text-[18px] text-glow-green mb-6 text-center"
          data-testid="login-title"
        >
          ◼ SIGN IN
        </h1>
        <form onSubmit={submit} className="flex flex-col gap-4">
          <div>
            <label className="font-pixel text-[9px] text-[#8b95a9] mb-2 block">
              EMAIL
            </label>
            <input
              type="email"
              required
              autoFocus
              data-testid="login-email-input"
              className="cb-input"
              value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })}
            />
          </div>
          <div>
            <label className="font-pixel text-[9px] text-[#8b95a9] mb-2 block">
              PASSWORD
            </label>
            <input
              type="password"
              required
              data-testid="login-password-input"
              className="cb-input"
              value={form.password}
              onChange={(e) => setForm({ ...form, password: e.target.value })}
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            data-testid="login-submit-btn"
            className="cb-neon-btn mt-2"
          >
            {loading ? "..." : "Enter"}
          </button>
        </form>
        <div className="mt-6 text-center text-xs text-[#8b95a9]">
          No account yet?{" "}
          <Link
            to="/register"
            className="text-[#2ecc71] hover:text-glow-green"
            data-testid="go-register-link"
          >
            Register
          </Link>
        </div>
      </div>
    </Layout>
  );
}
